import dbg from 'debug';

const debug = dbg('jp:exponea');

const exponeaTracking = (trackingName: string, data: any) => {
  debug(trackingName, data);
  if (__CLIENT__ && 'exponea' in window) {
    window.exponea.track(trackingName, {
      ...data
    });
  }
};

export default exponeaTracking;
